import { ScrollView } from "react-native-gesture-handler";
import i18n from 'i18n-js';
import React, {useEffect, useRef} from 'react';
import { useWindowDimensions } from 'react-native';
import RenderHtml from 'react-native-render-html';
import { useSafeAreaInsets } from "react-native-safe-area-context";
import { useDispatch, useSelector } from 'react-redux';
import BasicButton from "../components/basic/BasicButton";
import { acceptDPA, acceptTOU } from "../stores/mainSlice";

export default function AGB({ navigation }) {
    const scrollView = useRef()
    const settings = useSelector((state) => state.settings)
    const { width } = useWindowDimensions();
    const insets = useSafeAreaInsets()
    const source = useSelector((state) => settings.showTOU ? state.legal.tou_de : state.legal.dpa_de)

    const dispatch = useDispatch()

    // This fixes the bug that when changing from seeing the TOU to seeing the DPA the scrollView stayed where you were in the text before
    useEffect(() => {
        scrollView.current.scrollTo({ x: 0, y: 0, animated: false })
    }, [settings.showTOU])

    const doAcceptTOU = () => {
        dispatch(acceptTOU({ showTOU: false }))
    }

    const doAcceptDPA = () => {
        dispatch(acceptDPA({ showDPA: false }))
    }

    console.log("Rendering AGB, showTOU:", settings.showTOU)
    return (settings.showTOU ? (<ScrollView ref={scrollView} scrollIndicatorInsets={{ right: 1 }} contentContainerStyle={{ paddingBottom: 30 + insets.bottom }} className="flex-1 bg-secondary-50 py-3 px-3 mt-2">
        <RenderHtml contentWidth={width} source={source} />
        <BasicButton onPress={doAcceptTOU} text={i18n.t('tou.accept')}/>
    </ScrollView>) : (<ScrollView ref={scrollView} scrollIndicatorInsets={{ right: 1 }} contentContainerStyle={{ paddingBottom: 30 + insets.bottom }} className="flex-1 bg-secondary-50 py-3 px-3 mt-2">
        <RenderHtml contentWidth={width} source={source} />
        <BasicButton onPress={doAcceptDPA} text={i18n.t('dpa.accept')}/>
    </ScrollView>));
}
